import CustomFilterSelect from "./CustomFilterSelect";

const FilterDateNextYear = (props: any) => {
  const { source, label, variant } = props;
  //last one year
  const DateFilterData = [
    { id: "current", name: "Current Year" },
    { id: "next1", name: "Next Year" },
    { id: "next2_3", name: "Next 2-3 Years" },
    { id: "next3_5", name: "Next 3-5 Years" },
    { id: "next5", name: "> 5 Years Later" },
  ];
  return (
    <CustomFilterSelect
      source={source}
      label={label}
      choices={DateFilterData}
      before={props?.before != null && props.before !== "" ? props.before : ""}
    />
  );
};

export default FilterDateNextYear;
